import * as React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import {
  RadioButtons,
  TextInput,
} from '../../../../../widgets/FormikInputFieldV2';
import {
  CONTACT_CATEGORY_OPTION_SHIPPING_CONTACT_ONLY,
  CONTACT_CATEGORY_OPTIONS_ALL,
  ContactFormValues,
} from '../constants';
import { PhoneInput } from './PhoneInput';
import { ContactCategory } from '../../../../../constants';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../../../../reducers/session';
import { PartnerTypeEnum } from '../../../../../types';

const InputContainer = styled.div`
  max-width: 465px;
`;

const useContactCategoryOptions = () => {
  const customerPartnerType = useSelector(
    sessionSelector.getCustomerPartnerType,
  );

  return customerPartnerType === PartnerTypeEnum.MSP
    ? CONTACT_CATEGORY_OPTION_SHIPPING_CONTACT_ONLY
    : CONTACT_CATEGORY_OPTIONS_ALL;
};

export const InformationInputs: React.FunctionComponent = () => {
  const categoryOptions = useContactCategoryOptions();

  const {
    values: { contactCategory },
  } = useFormikContext<ContactFormValues>();

  const isDL = contactCategory === ContactCategory.DL;

  return (
    <InputContainer>
      <RadioButtons
        name="contactCategory"
        label="Type"
        options={categoryOptions}
        className="mb-4"
      />

      <TextInput
        name="firstName"
        required
        label={isDL ? 'Display Name' : 'First Name'}
      />

      {!isDL && <TextInput name="lastName" required label="Last Name" />}

      <TextInput name="email" required label="Email Address" />

      <PhoneInput />

      {contactCategory === ContactCategory.USER && (
        <TextInput name="role" label="Title" />
      )}
    </InputContainer>
  );
};
